<script setup>
import { useWebStore } from '@/store/web.js'
import SocialMedia from "@/components/SocialMedia.vue";

const store = useWebStore();

// A jogi oldalak 1280px alatt a hamburger menüben, felette KIZÁRÓLAG itt érhetők
// el: a fejléc menüsávjából kikerültek, mert a négy tevékenységi körrel együtt
// nem fértek el egy sorban. A `sites` tömbből jönnek, így nyelvhelyesek.
const legalLinks = computed(() =>
  store.sites.filter((site) => site.right && site.show !== false)
);

const columns= [
        {
          title: 'email',
          items: [
            { text: 'info@poliol.hu' },
            { text: 'sales@poliol.hu' }
          ]
        },
        {
          title: store.getLocaleString('fc4'),
          items: [
            { text: store.getLocaleString('fc5') },
            { text: '+36 30 116 9260', tel: '+36301169260' }
          ]
        },
        {
          title: store.getLocaleString('fc8'),
          items: [
            { text: '+36 76 448 544', tel: '+3676448544' }
          ]
        },
        {
          title: store.getLocaleString('fc10'),
          items: [
            { text: 'Poliol Gépgyártó és Csomagolástechnikai Kft.\nH-6065 Lakitelek, Tiszakécskei út 3.' }
          ]
        }
      ]
</script>

<template>
  <footer class="foundry-surface relative w-full border-t-4 border-orange-500">
    <div class="relative z-10 mx-auto max-w-screen-xl px-6 pb-10 pt-12 text-left text-[#c1c1c1] sm:px-10 sm:pt-16">

      <!-- REGION 1 — HEADER -->
      <div class="mb-10 flex items-start justify-between gap-6">
        <div class="flex items-start gap-4">
          <span class="mt-1 h-9 w-1.5 shrink-0 bg-orange-500"></span>
          <h2 class="m-0 font-['Space-Grotesk'] text-2xl font-bold uppercase leading-tight tracking-tighter text-white sm:text-3xl lg:text-4xl">
            {{ store.getLocaleString('fc1') }}
          </h2>
        </div>
        <img
          src="/poliol_logo_feher.webp"
          alt="Poliol Kft."
          class="hidden h-8 shrink-0 opacity-90 lg:block"
        />
      </div>

      <!-- REGION 2 — DATA GRID -->
      <div class="grid grid-cols-1 gap-x-10 gap-y-8 pb-10 sm:grid-cols-2 lg:grid-cols-4">
        <div
          v-for="(column, index) in columns"
          :key="index"
          class="min-w-0 border-t border-white/10 pt-4"
          :class="{ 'sm:col-span-2': index === columns.length - 1 }"
        >
          <h5 class="mb-2 text-base font-bold uppercase text-orange-500">
            {{ column.title }}
          </h5>
          <h6
            v-for="(item, i) in column.items"
            :key="i"
            class="m-0 break-words text-lg lg:text-xl"
            :class="{ 'pt-2': i > 0 }"
          >
            <a
              v-if="item.tel"
              :href="`tel:${item.tel}`"
              class="text-[#c1c1c1] no-underline transition-colors duration-200 hover:text-white"
            >{{ item.text }}</a>
            <template v-else v-for="(line, li) in item.text.split('\n')" :key="li">
              {{ line }}<br v-if="li < item.text.split('\n').length - 1" />
            </template>
          </h6>
        </div>
      </div>

      <!-- REGION 3 — UTILITY BAR -->
      <div class="mt-8 flex flex-col gap-6 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <social-media class="shrink-0" />

        <div class="flex flex-wrap items-center gap-x-3 gap-y-2">
          <template v-for="link in legalLinks" :key="link.url">
            <NuxtLink
              :to="`/${store.chosenLang}/${link.url}`"
              class="inline-flex items-center gap-2 text-sm no-underline text-[#c1c1c1] transition-colors hover:text-orange-500"
            >
              {{ link.text }}
            </NuxtLink>
            <span class="h-4 w-px bg-orange-500/30"></span>
          </template>

          <button
            type="button"
            @click="store.showGdpr"
            class="inline-flex items-center gap-2 text-sm text-[#c1c1c1] transition-colors hover:text-orange-500"
          >
            <UIcon name="i-heroicons-document-text-solid" class="h-4 w-4 bg-orange-500" />
            {{ store.getLocaleString('fc11') }}
          </button>

          <span class="h-4 w-px bg-orange-500/30"></span>

          <button
            type="button"
            @click="$router.push(`/${store.chosenLang}/${store.getLocaleString('im1')}`)"
            class="inline-flex items-center gap-2 text-sm text-[#c1c1c1] transition-colors hover:text-orange-500"
          >
            <UIcon name="i-heroicons-document-text" class="h-4 w-4 bg-orange-500" />
            {{ store.getLocaleString('im1') }}
          </button>
        </div>

        <div class="flex items-center gap-5 sm:ml-auto">
          <p class="m-0 text-sm text-white/50">{{ store.getLocaleString('fc9') }}</p>
          <NuxtLink :to="`/${store.chosenLang}/${store.sites[8].url}`" class="shrink-0">
            <img
              src="/szechenyi_plus_eu.webp"
              alt="Széchenyi Terv Plusz"
              class="h-12 opacity-90 transition-opacity hover:opacity-100"
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </footer>
</template>
